import React from "react"
import Figures from "./figures"
import { graphql, useStaticQuery } from "gatsby"

const figs = [
  {
    _typename: "thumbnail",
    reference: "1",
    image: "D01",
    size: 5,
    caption_en: {
      title: "Anne Savage Painting Outdoor",
      body: ", 1920s, Anne Savage Fonds, Concordia University Archives, file P146-02-021.",
      source: "",
    },
    caption_fr: {
      title: "Anne Savage peignant à l’extérieur",
      body:
        ", vers 1920-1930, Fonds Anne Savage, Archives de l’Université Concordia, document P146-02-021.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "2",
    image: "D02",
    size: 4,
    caption_en: {
      title: "Untitled (green forrest)",
      body: ", n.d.<br/>Oil on panel<br/>35,5 x 30,5 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1998<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (forêt verte)",
      body: ", n. d.<br/>Huile sur panneau<br/>35,5 x 30,5 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme T.W.L. McDermot, 1998<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "sound",
    reference: "3",
    sound: "D03",
    size: 1,
    caption_en: {
      body: "Arthur H. Calvin, <em>Interviews with Anne Savage</em>, September 1967, Anne Savage Fonds, Concordia University Archives, file 18.3., tape 1, 00:35:52 - 00:37:11.",
    },
    caption_fr: {
      body:
        "Arthur H. Calvin, <em>Entretiens avec Anne Savage</em>, septembre 1967, Fonds Anne Savage, Archives de l’Université Concordia, document 18.3 cassette 1, 00:35:52 - 00:37:11.",
    },
  },
  {
    _typename: "thumbnail",
    reference: "4",
    image: "D04_B",
    size: 3,
    caption_en: {
      title: "Untitled (sunflowers)",
      body: ", n.d.<br/>Oil on panel<br/>46 x 50,8 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1998<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (tournesols)",
      body: ", n. d.<br/>Huile sur panneau<br/>46 x 50,8 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme T.W.L. McDermot, 1998<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "5",
    image: "D05",
    size: 1,
    caption_en: {
      title: "Untitled (countryside Scene)",
      body: ", n.d.<br/>Graphite on paper<br/>15,8 x 37 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (scène de campagne)",
      body: ", n. d.<br/>Mine de plomb sur papier<br/>15,8 x 37 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "gallery",
    reference: ["6", "7", "8", "9", "10", "11"],
    image: ["D06", "D07", "D08", "D09", "D10", "D11"],
    size: 1,
    caption_en: [
      {
        title: "Untitled (landscape with winding road)",
        body: ", n.d.<br/>Oil on panel<br/>30,5 x 35,5 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1998<br/>Photo: Paul Smith",
      },
      {
        title: "Untitled (landscape with dead tree)",
        body: ", n.d.<br/>Oil on panel<br/>30,5 x 35,5 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Anne McDougall, A.T. Galt McDermot, Mary Drumond, Hellen Leslie & John B. Claxton, 1974<br/>Photo: Paul Smith",
      },
      {
        title: "Untitled (landscape with road)",
        body: ", n.d.<br/>Oil on panel<br/>30,5 x 35,5 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1974<br/>Photo: Paul Smith",
      },
      {
        title: "Early Spring",
        body: ", n.d.<br/>Oil on panel<br/>30,5 x 35,5 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1998<br/>Photo: Paul Smith",
      },
      {
        title: "Untitled (trees and broken fence)",
        body: ", n.d.<br/>Oil on panel<br/>30,7 x 35,5 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1974<br/>Photo: Paul Smith",
      },
      {
        title: "Untitled (landscape with farm buildings)",
        body: ", n.d.<br/>Oil on panel<br/>22,5 x 30,4 cm",
        source:
          "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1998<br/>Photo: Paul Smith",
      },
    ],
    caption_fr: [
      {
        title: "Sans titre (paysage avec chemin sinueux)",
        body: ", n. d.<br/>Huile sur panneau<br/>30,5 x 35,5 cm",
        source: "Université Concordia<br/>Don de Mme T.W.L. McDermot, 1998<br/>Photo : Paul Smith",
      },
      {
        title: "Sans titre (paysage avec arbre mort)",
        body: ", n. d.<br/>Huile sur panneau<br/>30,5 x 35,5 cm",
        source: "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Anne McDougall, A.T. Galt McDermot, Mary Drumond, Hellen Leslie & John B. Claxton, 1974<br/>Photo : Paul Smith",
      },
      {
        title: "Sans titre (paysage avec chemin)",
        body: ", n. d.<br/>Huile sur panneau<br/>30,5 x 35,5 cm",
        source: "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme T.W.L. McDermot, 1974<br/>Photo : Paul Smith",
      },
      {
        title: "Début du printemps",
        body: ", n. d.<br/>Huile sur panneau<br/>30,5 x 35,5 cm",
        source: "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme T.W.L. McDermot, 1998<br/>Photo : Paul Smith",
      },
      {
        title: "Sans titre (arbres et barrière brisée)",
        body: ", n. d.<br/>Huile sur panneau<br/>30,7 x 35,5 cm",
        source: "Université Concordia<br/>Don de Mme T.W.L. McDermot, 1974<br/>Photo : Paul Smith",
      },
      {
        title: "Sans titre (paysage avec bâtiments de ferme)",
        body: ", n. d.<br/>Huile sur panneau <br/>22,5 x 30,4 cm",
        source: "Université Concordia<br/>Don de Mme T.W.L. McDermot, 1998<br/>Photo : Paul Smith",
      },
    ],
  },
  {
    _typename: "thumbnail",
    reference: "12",
    image: "D12",
    size: 3,
    caption_en: {
      title: "Morning",
      body: ", 1963<br/>Oil on panel<br/>85,6 x 121,9 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of M. Sydney S. Harrison, 1963<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Matin",
      body: ", 1963<br/>Huile sur panneau<br/>85,6 x 121,9 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de M. Sydney S. Harrison, 1963<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "sketchbook",
    reference: "13",
    images: "D13",
    size: 4,
    caption_en: {
      title: "Sketchbook no.&nbsp;13",
      body: ",<br/>c. 1921<br/>Pencil on paper<br/>11,4 x 14,4 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      body:
        "<em>Carnet de croquis no&nbsp;13</em>, vers 1921<br/>Crayon sur papier<br/>11,4 x 14,4 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "14",
    image: "D14_B",
    size: 3,
    caption_en: {
      title: "Untitled (beginning of a landscape)",
      body: ", c. 1930<br/>Oil on panel<br/>40,2 x 45,9 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1997<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (début de paysage)",
      body: ", vers 1930<br/>Huile sur panneau<br/>40,2 x 45,9 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme T.W.L. McDermot, 1997<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "15",
    image: "D15_B",
    size: 4,
    caption_en: {
      title: "The Little Pine – Lake Wonish",
      body: ", n.d.<br/>Oil on canvas<br/>61,4 x 51 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the artist, 1969<br/>Photo: Paul Smith",
    },
    caption_fr: {
      title: "Le petit pin – Lac Wonish",
      body: ", n. d.<br/>Huile sur toile<br/>61,4 x 51 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de l’artiste, 1969<br/>Photo : Paul Smith",
    },
  },
  {
    _typename: "thumbnail",
    reference: "16",
    image: "D16",
    size: 3,
    caption_en: {
      title: "Mussel Shells – The Beach, Metis",
      body: ", n.d.<br/>Oil on panel<br/>30,5 x 36,2 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Dr. Naomi Jackson Groves, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Coquilles de moules – La plage, Métis",
      body: ", n. d.<br/>Huile sur panneau <br/>30,5 x 36,2 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Dr. Naomi Jackson Groves, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "17",
    image: "D17",
    size: 4,
    caption_en: {
      title: "Sandy Bay, Metis",
      body: ", 1951<br/>Coloured pencil on paper<br/>25,3 x 19 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Baie-des-Sables, Métis",
      body: ", 1951<br/>Crayon de couleur sur papier<br/>25,3 x 19 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "18",
    image: "D18",
    size: 4,
    caption_en: {
      title: "Untitled (curvilinear sketch of a tree)",
      body: ", n.d.<br/>Pencil on paper mounted on cardboard<br/>24 x 18 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",

    },
    caption_fr: {
      title: "Sans titre (croquis curvilinéaire d’un arbre)",
      body: ", n. d.<br/>Crayon sur papier marouflé sur carton<br/>24 x 18 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "19",
    image: "D19",
    size: 2,
    caption_en: {
      title: "Untitled (boat and village)",
      body: ", n.d.<br/>Pencil on paper mounted on cardboard<br/>22,3 x 30 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (bateau et village)",
      body:
        ", n. d.<br/>Crayon sur papier marouflé sur carton<br/>22,3 x 30 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "20",
    image: "D20",
    size: 1,
    caption_en: {
      title: "Untitled (sunflowers)",
      body: ", n.d.<br/>Graphite on paper <br/>21,5 x 35,5 cm",
      source: "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of the Anne Savage Estate, 1989<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (tournesols)",
      body: ", n. d.<br/>Mine de plomb sur papier<br/>21,5 x 35,5 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de la succession Anne Savage, 1989<br/>Photo : Paul Litherland",
    },
  },
  {
    _typename: "thumbnail",
    reference: "21",
    image: "D21",
    size: 3,
    caption_en: {
      title: "Untitled (sunflowers)",
      body: ", n.d.<br/>Oil on panel <br/>46 x 50,5 cm",
      source:
        "Collection of the Leonard & Bina Ellen Art Gallery, Concordia University<br/>Gift of Mrs. T.W.L. McDermot, 1998<br/>Photo: Paul Litherland",
    },
    caption_fr: {
      title: "Sans titre (tournesols)",
      body: ", n. d.<br/>Huile sur panneau<br/>46 x 50,5 cm",
      source:
        "Collection de la Galerie Leonard & Bina Ellen, Université Concordia<br/>Don de Mme T.W.L. McDermot, 1998<br/>Photo : Paul Litherland",
    },
  },
]

export default ({ size }) => {
  const data = useStaticQuery(query)

  return <Figures data={data} figures={figs} pre="depeindre" size={size} />
}

export const query = graphql`
  fragment thumbnailImage on File {
    childImageSharp {
      # fluid(maxWidth: 1800, base64Width: 1) {
      #   ...GatsbyImageSharpFluid
      # }
      fluid(maxWidth: 1800) {
        ...GatsbyImageSharpFluid_noBase64
      }
      original {
        width
        height
        src
      }
    }
  }
  fragment smallThumbnailImage on File {
    childImageSharp {
      fluid(maxWidth: 1800) {
        ...GatsbyImageSharpFluid
      }
      original {
        width
        height
        src
      }
    }
    # full: childImageSharp {
    #   fixed {
    #     base64
    #   }
    #   original {
    #     width
    #     height
    #     src
    #   }
    # }
  }
  query {
    D01: file(relativePath: { eq: "depeindre/D_01.jpg" }) {
      ...thumbnailImage
    }
    D02: file(relativePath: { eq: "depeindre/D_02.jpg" }) {
      ...thumbnailImage
    }
    D03: file(relativePath: { eq: "depeindre/D_03.mp3" }) {
      publicURL
    }
    D04_B: file(relativePath: { eq: "depeindre/D_04_B.jpg" }) {
      ...thumbnailImage
    }
    D05: file(relativePath: { eq: "depeindre/D_05.jpg" }) {
      ...thumbnailImage
    }
    D06: file(relativePath: { eq: "depeindre/D_06.jpg" }) {
      ...smallThumbnailImage
    }
    D07: file(relativePath: { eq: "depeindre/D_07.jpg" }) {
      ...smallThumbnailImage
    }
    D08: file(relativePath: { eq: "depeindre/D_08.jpg" }) {
      ...smallThumbnailImage
    }
    D09: file(relativePath: { eq: "depeindre/D_09.jpg" }) {
      ...smallThumbnailImage
    }
    D10: file(relativePath: { eq: "depeindre/D_10.jpg" }) {
      ...smallThumbnailImage
    }
    D11: file(relativePath: { eq: "depeindre/D_11.jpg" }) {
      ...smallThumbnailImage
    }
    D12: file(relativePath: { eq: "depeindre/D_12.jpg" }) {
      ...thumbnailImage
    }
    D13: allFile(
      filter: {
        relativePath: { regex: "/^depeindre/D_13 Sketchbook 13/" }
        sourceInstanceName: { eq: "images" }
      }
      sort: { fields: base }
    ) {
      edges {
        node {
          base
          ...thumbnailImage
        }
      }
    }
    D14_B: file(relativePath: { eq: "depeindre/D_14_B.jpg" }) {
      ...thumbnailImage
    }
    D15_B: file(relativePath: { eq: "depeindre/D_15_B.jpg" }) {
      ...thumbnailImage
    }
    D16: file(relativePath: { eq: "depeindre/D_16.jpg" }) {
      ...thumbnailImage
    }
    D17: file(relativePath: { eq: "depeindre/D_17.jpg" }) {
      ...thumbnailImage
    }
    D18: file(relativePath: { eq: "depeindre/D_18.jpg" }) {
      ...thumbnailImage
    }
    D19: file(relativePath: { eq: "depeindre/D_19.jpg" }) {
      ...thumbnailImage
    }
    D20: file(relativePath: { eq: "depeindre/D_20.jpg" }) {
      ...thumbnailImage
    }
    D21: file(relativePath: { eq: "depeindre/D_21.jpg" }) {
      ...thumbnailImage
    }
  }
`
